<template lang="pug">
  .b-crm-rejection-reason
    ._title Отказ по заявке
    ._hint Выберите причину отказа
    ul._list
      li._item(v-for="reason in reasons" :key="reason.id")
        button._button(type="button" @click="pick(reason)") {{ reason.name }}
</template>

<script>
/**
 * Выбор причины отказа при переводе заявки в «Отказ». Не форма с селектом,
 * а просто список: причин обычно немного, и один клик по пункту сразу
 * закрывает попап (см. crmModel#askRejectionReason).
 *
 * Резолвится объектом причины или false, если попап закрыли крестиком.
 */
export default {
  name: 'CrmRejectionReasonPopupWrappable',
  data() {
    return {
      reasons: [],
    };
  },
  methods: {
    init(params = {}) {
      this.reasons = params.reasons ?? [];
    },
    pick(reason) {
      this.$emit('finish', reason);
    },
  },
};
</script>

<style scoped lang="scss">
.crm-rejection-reason {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 520px;
  max-width: 100%;
  box-sizing: border-box;

  &__title {
    font-size: 36px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.02em;
    word-break: break-word;
  }

  &__hint {
    font-size: 12px;
    color: var(--color-middle-gray);
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 0;
    padding: 0;
    list-style: none;
    max-height: 60vh;
    overflow-y: auto;
  }

  &__button {
    display: block;
    width: 100%;
    padding: 12px 15px;
    border: none;
    border-radius: 10px;
    background: var(--color-super-light);
    color: var(--color-dark-gray);
    font: inherit;
    font-size: 14px;
    line-height: 1.3;
    text-align: left;
    word-break: break-word;
    cursor: pointer;
    transition: background-color .15s;

    &:hover,
    &:focus-visible {
      background: var(--color-purple);
    }
  }

  @media (max-width: 576px) {
    gap: 15px;

    &__title {
      font-size: 24px;
      line-height: 1.2;
    }
  }
}
</style>
